import { MessageCircle, Send } from 'lucide-react';
import { Button } from '@/components/ui/button';

const Footer = () => {
  return (
    <footer className="border-t border-border/50 bg-background/50 backdrop-blur-sm">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Powered by TAM */}
          <div className="text-center md:text-left">
            <p className="text-sm text-muted-foreground">
              Powered by <span className="font-semibold text-primary">TAM</span>
            </p>
            <p className="text-xs text-muted-foreground mt-1">
              © {new Date().getFullYear()} TAM Store. All rights reserved.
            </p>
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-2">
            <Button
              variant="ghost"
              size="sm"
              className="gap-2 text-muted-foreground hover:text-foreground"
              onClick={() => window.open('https://t.me/tam_tech786', '_blank')}
            >
              <Send className="h-4 w-4" />
              Telegram
            </Button>
            <Button
              variant="ghost"
              size="sm"
              className="gap-2 text-muted-foreground hover:text-foreground"
              onClick={() => window.open('https://whatsapp.com/channel/0029VbAozL4FMqrRJcbpJc1K', '_blank')}
            >
              <MessageCircle className="h-4 w-4" />
              WhatsApp
            </Button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
